import React, { useCallback, useEffect, useState, useRef } from 'react';
const SERVICES = ['Custom Cut', 'Fade', 'Buzz Cut', 'Scissor Cut', 'Shape Up', 'Curly Style', 'Beard Trim', 'Beard Conditioning', "Kids' Cut", 'Full Shave'];
const NAMES = ['Carlos', 'Miguel', 'David', 'Alex', 'Jose', 'Daniel', 'Luis', 'Marco', 'Adrian', 'Tony', 'Chris', 'Juan', 'Roberto', 'Gabriel', 'Andres', 'Diego', 'Fernando', 'Javier', 'Ricardo', 'Eduardo', 'Manuel', 'Pedro', 'Rafael', 'Victor', 'Oscar', 'Alejandro', 'Enrique', 'Sergio', 'Pablo', 'Hector', 'Orlando', 'Raul'];
const CITIES = ['Hialeah', 'Miami', 'Miami Lakes', 'Doral', 'Miami Gardens', 'Hialeah Gardens', 'Kendall', 'Coral Gables', 'Sweetwater', 'Westchester', 'Fontainebleau', 'Opa-locka', 'Medley'];
const TIMES = ['2 min ago', '5 min ago', '8 min ago', '12 min ago', '15 min ago', '20 min ago', '25 min ago', '30 min ago'];
function pickRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function randomInterval(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
type Notification = {
  name: string;
  city: string;
  service: string;
  time: string;
};
export function RecentBookingToast() {
  const [notification, setNotification] = useState<Notification | null>(null);
  const [visible, setVisible] = useState(false);
  const [exiting, setExiting] = useState(false);
  const nameHistoryRef = useRef<string[]>([]);
  const prefersReducedMotion = useRef(false);
  useEffect(() => {
    prefersReducedMotion.current = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }, []);
  const getUniqueName = useCallback(() => {
    const history = nameHistoryRef.current;
    const available = NAMES.filter(n => !history.includes(n));
    const pool = available.length > 0 ? available : NAMES;
    const name = pickRandom(pool);
    history.push(name);
    if (history.length > 10) history.shift();
    return name;
  }, []);
  const showNotification = useCallback(() => {
    const notif: Notification = {
      name: getUniqueName(),
      city: pickRandom(CITIES),
      service: pickRandom(SERVICES),
      time: pickRandom(TIMES)
    };
    setNotification(notif);
    setExiting(false);
    setVisible(true);
    // Hide after 4s
    setTimeout(() => {
      setExiting(true);
      setTimeout(() => {
        setVisible(false);
        setNotification(null);
        setExiting(false);
      }, 500);
    }, 4000);
  }, [getUniqueName]);
  useEffect(() => {
    // First notification after 3s
    const firstTimer = setTimeout(() => {
      showNotification();
    }, 3000);
    // Then repeat at random intervals
    let intervalTimer: ReturnType<typeof setTimeout>;
    const scheduleNext = () => {
      const delay = randomInterval(8000, 15000);
      intervalTimer = setTimeout(() => {
        showNotification();
        scheduleNext();
      }, delay);
    };
    // Start the recurring cycle after first one
    const startRecurring = setTimeout(() => {
      scheduleNext();
    }, 7500); // 3s initial + 4s display + 0.5s buffer
    return () => {
      clearTimeout(firstTimer);
      clearTimeout(startRecurring);
      clearTimeout(intervalTimer);
    };
  }, [showNotification]);
  if (!visible || !notification) return null;
  const animClass = prefersReducedMotion.current ? '' : exiting ? 'toast-exit' : 'toast-enter';
  return <div className={`fixed bottom-6 left-1/2 z-[90] ${animClass}`} style={{
    transform: 'translateX(-50%)',
    maxWidth: '380px',
    width: 'calc(100% - 32px)',
    pointerEvents: 'none'
  }} role="status" aria-live="polite" data-id="element-459">
      <div className="flex items-center gap-3 px-4 py-3 rounded-lg" style={{
      backgroundColor: 'rgba(17,17,17,0.97)',
      border: '1px solid rgba(201,168,76,0.3)',
      boxShadow: '0 8px 32px rgba(0,0,0,0.5), 0 0 20px rgba(201,168,76,0.06)',
      backdropFilter: 'blur(12px)'
    }} data-id="element-460">
        {/* Icon */}
        <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center" style={{
        backgroundColor: 'rgba(201,168,76,0.12)',
        border: '1px solid rgba(201,168,76,0.3)'
      }} data-id="element-461">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-462">
            <circle cx="6" cy="6" r="3" data-id="element-463" />
            <circle cx="6" cy="18" r="3" data-id="element-464" />
            <line x1="20" y1="4" x2="8.12" y2="15.88" data-id="element-465" />
            <line x1="14.47" y1="14.48" x2="20" y2="20" data-id="element-466" />
            <line x1="8.12" y1="8.12" x2="12" y2="12" data-id="element-467" />
          </svg>
        </div>

        {/* Text */}
        <div className="flex-1 min-w-0" data-id="element-468">
          <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: '0.82rem',
          color: '#F5F5F5',
          lineHeight: 1.4,
          margin: 0
        }} data-id="element-469">
            <span style={{
            fontWeight: 600,
            color: '#C9A84C'
          }} data-id="element-470">
              {notification.name}
            </span>{' '}
            from {notification.city} just booked a{' '}
            <span style={{
            fontWeight: 600
          }} data-id="element-471">
              {notification.service}
            </span>
          </p>
          <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: '0.7rem',
          color: '#666',
          margin: '2px 0 0'
        }} data-id="element-472">
            {notification.time}
          </p>
        </div>

        {/* Live dot */}
        <div className="flex-shrink-0" style={{
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        backgroundColor: '#4ade80',
        animation: 'holo-pulse 2s ease-in-out infinite'
      }} aria-hidden="true" data-id="element-473" />
      </div>
    </div>;
}